import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * ProtectedRoute
 * @param {string} role - required role: "customer" | "provider" | "admin"
 *
 * Rules:
 *  - Not logged in          → /login  (with redirect back after login)
 *  - Logged in, wrong role  → their own dashboard
 *  - Logged in, correct role → render children
 */
const ROLE_HOME = {
  customer: "/customer/dashboard",
  provider: "/provider/dashboard",
  admin:    "/admin/dashboard",
};

export default function ProtectedRoute({ role }) {
  const { user } = useAuth();
  const location = useLocation();

  // Not authenticated → go to login, remember where they were
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authenticated but wrong role → redirect to their own dashboard
  if (user.role !== role) {
    return <Navigate to={ROLE_HOME[user.role] ?? "/login"} replace />;
  }

  return <Outlet />;
}
